import React from "react";

interface MobileFeatureCardProps {
  icon: string;
  title: string;
  description: string;
}

const MobileFeatureCard: React.FC<MobileFeatureCardProps> = ({
  icon,
  title,
  description,
}) => {
  return (
    <div className="flex items-center gap-6 w-full bg-gray-100 rounded-2xl p-6 shadow-sm hover: transition-colors duration-300 transform hover:scale-105">
      <div className="bg-customGreenLight p-4 rounded-2xl min-w-[60px] min-h-[60px] flex items-center justify-center">
        <img
          src={icon}
          alt={title}
          className="w-full h-full object-contain max-w-[28px] max-h-[28px]"
        />
      </div>
      <div className="flex flex-col gap-1">
        <h3 className="font-helveticaBold text-base text-black text-wrap">
          {title}
        </h3>
        <p className="text-gray-500 text-xs font-helvetica">{description}</p>
      </div>
    </div>
  );
};

export default MobileFeatureCard;
